import {createRouter, createWebHistory} from 'vue-router';
import auth from '@/commons/authService';
import routerService from '@/commons/routerService';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import routerPage from './routerPage';
import routerDI from './routerDI';
import routerDemo from './routerDemo';
import routerCommon from './routerCommon';
import routerShared from './routerShared';
import routerDIV3 from './routerDIV3';
import routerEstimate from './routerEstimate';
import routerThreeYearEstimate from './routerThreeYearEstimate';
import routerLoanRepayment from './routerLoanRepayment';
import routerEstimateArrgrate from './routerEstimateArrgrate';
import routerAllocation from './routerAllocation';
import routerExamine from './routerExamine';
import routerEnact from './routerEnact';
import routerBeforeData from './routerBeforeData';
import routerSummary from './routerSummary';
import routerReport from './routerReport';
import routerOrganizationUnder from './routerOrganizationUnder';
import routerRoleManagement from './routerRoleManagement';
import routerEstimateSectorWide from './routerEstimateSectorWide';
import routerHistory from './routerHistory';
import routerSetting from './routerSetting';
import routerTracking from './routerTracking';
import {useContextStore} from '@/stores/context';
const routes = [
  {
    path: '',
    component: () => import('@/layouts/MainLayout.vue'),
    meta: {
      // anonymous: true
    },
    children: [
      // default home
      {
        path: '',
        redirect: '/dictionaryV3',
        meta: {},
      },
      ...routerDemo,
      ...routerExamine,
      ...routerShared,
      ...routerDI,
      ...routerDIV3,
      ...routerEstimate,
      ...routerThreeYearEstimate,
      ...routerLoanRepayment,
      ...routerEstimateArrgrate,
      ...routerAllocation,
      ...routerEnact,
      ...routerBeforeData,
      ...routerSummary,
      ...routerReport,
      ...routerOrganizationUnder,
      ...routerRoleManagement,
      ...routerEstimateSectorWide,
      ...routerHistory,
      ...routerSetting,
      ...routerTracking,
      ...routerCommon
    ],
  },
  ...routerPage,
  {
    // Redirect to 404 page, if no match found
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName:'pages'*/ '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
];

const router = createRouter({
  // history: createWebHistory('/demo-project/'),
  history: createWebHistory(import.meta.env.VITE_BASE_URL || '/'),
  routes,
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\S)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   if (isChunkLoadFailed && window._appConfig.showLoadChunkFail) {
//     messageBox.showError(i18n.t("i18nSY.LoadChuckFail")).then(() => {
//       window.location.reload();
//     });
//   }
// });

// router.onReady(routerOnReady, routerOnError);

router.afterEach(() => {
  commonFn.unmask();
});

router.beforeEach((to, from, next) => {
  // khi chuyển router sẽ show maskloading cho người dùng biết xử lý
  // do tình huông tải file js chậm
  // trong after sẽ ẩn mask loading đi
  // Tạm thời dùng loading global, sau này có thể làm kiểu thanh line chạy ngay dưới address bar sau
  commonFn.mask();

  // hide all popup
  // TODO => Ẩn tất cả popup ở đây
  popupUtil.hideAll();

  // trang không authen
  if (to.meta.anonymous) {
    next();
    return;
  }

  // kiểm tra authen -> fail redirect login
  if (!auth.isAuthenticated()) {
    auth.login(to.fullPath);
    return;
  }

  // kiểm tra xác nhận thỏa thuận hay chưa, chưa thì ko đang sang màn hình khác
  let guardRouter = guardTermsPrivacy(to.fullPath);

  if (guardRouter) {
    next(guardRouter);
    return;
  }

  commonFn.showpopupUtilToParams(to);

  if (!routerService.isValidRouter(to)) {
    next({name: 'dictionaryV3'});
    return;
  }

  // default
  next();
});

/**
 * "bảo vệ" màn hình xác nhận thỏa thuận/ chính sách
 *  NXPHONG 18/12/2024
 */
const guardTermsPrivacy = toRouterPath => {
  const contextStore = useContextStore();
  // nếu chưa xác nhận
  if (
    contextStore.Context?.TermsPrivacy &&
    toRouterPath !== '/logout' &&
    toRouterPath !== '/login' &&
    toRouterPath !== '/terms-privacy'
  ) {
    return '/terms-privacy';
  } else if (!contextStore.Context?.TermsPrivacy && toRouterPath === '/terms-privacy') {
    return '/';
  }
  return null;
};

export default router;
